import { Input } from '@arco-design/web-react';
import React from 'react'

const InputSearch = Input.Search;
function MenuHeader({ headerName, btnLabel, handleChange, searchText, clearSearch, handlesearchTextChange, handleSearch }) {
  return (
    <div className="mb-3">
      <div className="align-items-center row justify-content-end flex-wrap">
        <div className={`${headerName ? "col-12  col-md-6 " : "  col-12 col-sm-3 col-md-4 col-lg-2"}`}>
          <div className='d-flex flex-column flex-md-row w-100 gap-2'>
            {headerName &&
              <>
                <InputSearch value={searchText} onChange={handlesearchTextChange} allowClear placeholder='Account name' />
                <button className="btn btn-master px-4 rounded  fw_500 font_12" onClick={handleSearch}>Search</button>
                {clearSearch && 
                  <button className="btn btn-master px-4 rounded  fw_500 font_12" onClick={clearSearch}>Clear</button>
                }
              </>
            }
            {btnLabel &&
              <button
              className="btn px_btn btn-master px-4 rounded  fw_500 font_12 w-100"
              onClick={handleChange}
            >
              {btnLabel}

            </button>
            }
            
          </div>
        </div>
      </div>
    </div>
  )
}

export default MenuHeader
